import {
  contentTypeCategoryToCodeLanguage,
  convertHeadersToArray,
  getContentType,
  getContentTypeCategory,
} from '@carboncopyco/editor-utils';
import type { HTTPMessage } from '@carboncopyco/types';
import { ImageBox } from '../../../ImageBox';
import { TransactionContent } from './TransactionContent';

export interface BodyContentProps {
  message: HTTPMessage;
  onChange?: (value: string) => void;
  searchValue?: string;
}

export const BodyContent = ({
  message,
  onChange,
  searchValue,
}: BodyContentProps) => {
  const body = message.body ?? '';
  const headers = convertHeadersToArray(message.headers);
  const contentType = getContentType(headers);
  const contentTypeCategory = getContentTypeCategory(contentType);

  if (contentTypeCategory === 'image') {
    return (
      <div className="p-4">
        <ImageBox
          url={`data:${contentType};base64,${body}`}
          size={296}
        />
      </div>
    );
  }

  return (
    <TransactionContent
      value={body}
      language={contentTypeCategoryToCodeLanguage[contentTypeCategory]}
      onChange={onChange}
      searchValue={searchValue}
    />
  );
};
